export default class Part {
    static render(width, mods) {
        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = 20
        let y = 117.7
        return `<image href="${PARTS['switch_2']}" x="${x}" y="${y}" />`
    }
}
